import React, {useEffect, useRef, useState} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {sendRequestQuduq} from "../../api/request";

const ModalFilter = ({stId}) => {

    const dateNow = new Date()
    const year = dateNow.getFullYear()
    let month = dateNow.getMonth() + 1
    let day = dateNow.getDate()
    if (month < 10) month = '0' + month
    if (day < 10) day = '0' + day
    const today = `${year}-${month}-${day}`

    const inputRef = useRef();
    const [datee, setDatee] = useState(today)
    const [loading, setLoading] = useState(false)
    const [dataone, setDataone] = useState(new Date().toLocaleString() + "")

    const dayHandler = () => {
        const getDataOne = async () => {
            setLoading(false)
            if (!stId) return null
            try {
                await sendRequestQuduq({
                    url: `data-one?stId=${stId}&date=${datee}`,
                    method: "GET",
                }).then((res) => {
                    if (res) setLoading(true)
                    setDataone(res)
                });
            } catch (e) {
                console.log(e)
            }
        }
        getDataOne()
    }

    useEffect(() => {
        const getDataOne = async () => {
            if (!stId) return null
            try {
                await sendRequestQuduq({
                    url: `data-one?stId=${stId}&date=${datee}`,
                    method: "GET",
                }).then((res) => {
                    if (res) setLoading(true)
                    setLoading(true)
                    setDataone(res)
                });
            } catch (e) {
                console.log(e)
            }
        }
        getDataOne()
    }, [stId])

    return (
        <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="staticBackdropLabel">Dayver</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="mb-3 px-md-5">
                                <div className="d-flex justify-content-center">
                                    <input
                                        ref={inputRef}
                                        type="date"
                                        className="form-control"
                                        style={{maxWidth: "300px"}}
                                        value={datee}
                                        onChange={() => setDatee(inputRef.current.value)}
                                    />
                                    <button onClick={dayHandler} type="button" className="ms-2 btn btn-info">
                                        <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" /> Qidirish
                                    </button>
                                </div>
                            </div>
                        </form>
                        <div className="row">
                            <div className="col-md-7">
                                <div className="table-responsive" style={{height: "550px", overflow: "scroll"}}>
                                    <table className="table table-bordered table-hover">
                                        <thead className="text-center table-primary align-middle sticky-top " style={{top: "-1px", lineHeight: "18px"}}>
                                        <tr>
                                            <th scope="col" colSpan={6}>{dataone.data?.stations[0].obekt}</th>
                                        </tr>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Sath (mm)</th>
                                            <th scope="col">Mineral (g/l)</th>
                                            <th scope="col">Temperatura C<sup>0</sup></th>
                                            <th scope="col">Qurulma o'lchagan vaqt</th>
                                            <th scope="col">IP</th>
                                        </tr>
                                        </thead>
                                        <tbody className="text-center"  >
                                        {
                                            loading ?
                                                dataone.data?.datas.length > 0 ?
                                                    dataone.data?.datas.map((item, index) =>
                                                        <tr key={index}>
                                                            <th scope="row">{index+1}</th>
                                                            <td>{item.level}</td>
                                                            <td>{item.mineral}</td>
                                                            <td>{item.temperatura}</td>
                                                            <td>{item.sana}</td>
                                                            <td>{item.sana}</td>
                                                        </tr>
                                                    ) : <tr className="py-4 alert mt-3">
                                                        <td className="py-4 bg-light text-danger" colSpan={6}><FontAwesomeIcon color="#dc3545" icon="fa-solid fa-triangle-exclamation" />
                                                            {
                                                                dataone.data?.stations[0].sana ?
                                                                    <>
                                                                        <strong style={{lineHeight: "50px"}}> Ushbu kunda bu qurulmadan ma'lumot kelmagan!</strong>
                                                                        <p className="text-black text-start">Eng oxirgi kelgan vaqti:
                                                                            <strong
                                                                                onClick={
                                                                                    () => setDatee(dataone.data?.stations[0].sana.slice(0,4)+"-"+dataone.data?.stations[0].sana.slice(4,6)+"-"+dataone.data?.stations[0].sana.slice(6,8))}
                                                                                style={{cursor: "pointer"}} className="text-primary text-decoration-underline ms-1"
                                                                            >
                                                                                {dataone.data?.stations[0].sana.slice(6,8)+"-"+dataone.data?.stations[0].sana.slice(4,6)+"-"+dataone.data?.stations[0].sana.slice(0,4)}
                                                                            </strong>
                                                                        </p>
                                                                    </>
                                                                    : <strong style={{lineHeight: "50px"}}> Bu qurulmadan umuman ma'lumot kelmagan!</strong>
                                                            }
                                                        </td>
                                                    </tr>
                                                : <tr><td colSpan={6}>Yuklanmoqda</td></tr>
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="col-md-5">
                                <div className="card mb-3" >
                                    <div className="card-header bg-warning  text-center "><strong>Qurulma haqida</strong></div>
                                    <div className="card-body text-center">
                                        <h6 className="card-title mb-1">Viloyat: {dataone.data?.stations[0].vil_nomi}</h6>
                                        <h6 className="card-title mb-1">Tuman: {dataone.data?.stations[0].tum_nomi}</h6>
                                        <h6 className="card-title mb-1">Yil hisobi: {dataone.data?.stations[0].made}</h6>
                                        <h6 className="card-title mb-1">KOD/IMEI: {dataone.data?.stations[0].code}</h6>
                                        <h6 className="card-title mb-1">Integratsiya vaqti: {dataone.data?.stations[0].created_at}</h6>
                                        <h6 className="card-title mb-1">Balans tashkilot: {dataone.data?.stations[0].name}</h6>
                                        <h6 className="card-title mb-3">Pudratchi: {dataone.data?.stations[0].company}</h6>
                                        <h6 className="card-text text-danger"><FontAwesomeIcon color="#dc3545" icon="fa-solid fa-triangle-exclamation" /> Eslatma: Ma'lumotlar pudratchilardan olingan</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button onClick={() => (setDatee(today), setLoading(false), setDataone(""))} type="button" className="btn btn-secondary" data-bs-dismiss="modal"><FontAwesomeIcon color="red" icon="fa-solid fa-xmark" /> Yopish</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalFilter;